import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { BsThreeDotsVertical } from "react-icons/bs";
import ReactLoading from "react-loading";
import fetchApi from './Api';
import {imgdata,imgtext} from './database/firebase'
import { getDownloadURL, uploadBytes } from 'firebase/storage';
import  databaseFunctions from './database/firebase'
// import Sidebar from './Sidebar';

// UserDetails :{name: name , watchLater: [], watchHistory:[], details:[]}

// const [userDetails,setUserDetails] = useState({
//   "watchLater" : [],
//   "watchHistory" : [],
//   "details" : [],
//   'name' : "name"

// })



// import InfiniteScroll from 'react-infinite-scroller';
// import InfiniteScrollComponent from './sub-components/InfiniteScrollComponent'

// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// const { getFirestore, Timestamp, FieldValue, Filter } = require('firebase-admin/firestore');



// // import firebase from './database/firebase';
// import { initializeApp } from 'firebase/app';
// import { getFirestore, collection, getDocs } from 'firebase/firestore/lite';
// // Follow this pattern to import other Firebase services
// // import { } from 'firebase/<service>';

// // TODO: Replace the following with your app's Firebase project configuration
// const firebaseConfig = {
//   //...
// };

// const app = initializeApp(firebaseConfig);
// const db = getFirestore(app);

// // Get a list of cities from your database
// async function getCities(db) {
//   const citiesCol = collection(db, 'cities');
//   const citySnapshot = await getDocs(citiesCol);
//   const cityList = citySnapshot.docs.map(doc => doc.data());
//   return cityList;
// }



const WorkingonIt = () => {

    const [items, setItems] = useState([0,1,2,3,4,5,6,7,5,43,2,4,3,4,56,7,5,4,3,5,6,78,8,9,6,5,3,2,5,6,7]);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const [VedioArr, setVedioArr] = useState([]);
  
  



  

    const loadMoreItems = page => {
        
        setHasMore(false)
        fetchApi('search/?part=snippet','&country=in&query=dance'+`&page=${page}`)
        .then((videos)=>{
          
          
          setVedioArr(prev => [...prev, ...videos.data.videos]);
          setHasMore(true)
          
          return true
        })
    //   setTimeout(()=>{
    //     setItems(prevItems => [...prevItems, 0, 3, 5, 3, 42, 32, 2]);

    //   },1500)
  };
  
       

        const database = () => {
          // Example data to be saved
          const postData = {
            name: 'John Doe',
            email: 'john@example.com',
            age: 30
          };
        
          // Reference to the Firebase database location where data will be stored
          // const dbRef = firebase.database().ref('users');
        
          // // Write data to Firebase using set() method
          // dbRef.set(postData)
          //   .then(() => {
          
          //   })
          //   .catch(error => {
          //     console.error('Error saving data:', error);
          //   });
        };























        
            const firebaseConfig = {
                    apiKey: "AIzaSyBvswCh3Pmk2reULqT4aa0b-Hkp7GHWYB8",
                    authDomain: "play-tube-418206.firebaseapp.com",
                    projectId: "play-tube-418206",
                    storageBucket: "play-tube-418206.appspot.com",
                    messagingSenderId: "179733357122",
                    appId: "1:179733357122:web:9118ca3cbce424e269c3db",
                    measurementId: "G-53NDQJLL84"
                  };

        const RealTimeDatabase = async()=>{

          const myData = {
            fName : "Ram Chandra ki jay",
            fame: "game",
            id : 6,
            
          }
          
          
          
          let response = await fetch('https://playtubedataset-default-rtdb.firebaseio.com/MyData.json',{
            method:'POST',
            headers:{
              "Content-Type": "application/json"
            },
           
            body:JSON.stringify(myData)
          })


          if(response)
            {
              
            }
            else{
            
            }


        }
    

        const GetFirebaseData =  async()=>{

          let response = await fetch('https://playtubedataset-default-rtdb.firebaseio.com/MyData.json')
          response = await response.json();
          
        }


        const fireStoreData = (e)=>{
            
            // const image = ref(imgdata, "imgs/34534");
            // uploadBytes("imgs", e.target.files[0]).then((data)=>{
            
            //     getDownloadURL(data.ref).then((values)=>{

            //     })
            // })
        }

        const goToLoad =()=>{
          
        }

        const data = ()=>{

          let data = JSON.parse(localStorage.getItem("userDetails"))
          data["name"] = "Shree Ram";
          localStorage.setItem("userDetails", JSON.stringify(data));
          let data2 = localStorage.getItem("userDetails")
          
          
        }

        
  const addToDatabase = async (vidData) => {


    
    

    let response = await fetch('https://playtubedataset-default-rtdb.firebaseio.com/MyData.json', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },

      body: JSON.stringify(vidData)
    })


    if (response) {
      
    }
    else {
      
    }


  }


        const addData =async()=>{
          
              let response = await fetch('https://playtubedataset-default-rtdb.firebaseio.com/MyData.json')
              response = await response.json();

              

          
          response.forEach(ele => {
            // adding category
            // ele.keywords.push(selectedCategory)

            
            
            
             addToDatabase(ele)
          });

        }

  return (
    <>

   
        

          
      {/* <Sidebar/> */}
    <div className='h-[90vh]  w-[100vw] flex items-center flex-col  justify-center text-3xl font-bold bg-black text-white font-cursive'>
     
        <div className="w-[24rem] p-2 text-center ">
            Sorry for inconvenience!
            We are working on it.
        </div>
        <Link to='/' className='p-3  rounded-md w-fit font-bold text-xl hover:bg-gray-600 mt-4 bg-gray-400 text-red-500'>&lt;-  Back</Link>

        {/* <button class="focus:outline-none text-white bg-green-500 hover:bg-green-700 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800" onClick={()=>addData()}>Shree Ram</button> */}
{/* 
        <div id="Details" className="mic z-40 h-60 w-80 bg-gray-500 rounded-md shadow-xl absolute top-[16rem] left-[34rem] flex justify-around item-center flex-col ">
                  <div className="flex flex-col mx-3 ">

                  
                        <label htmlFor="website-admin" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Enter Your Name</label>
                        <div className="flex">
                          <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md dark:bg-gray-600 dark:text-gray-400 dark:border-gray-600">
                            <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z"/>
                            </svg>
                          </span>
                          <input type="text" id="website-admin" className="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="elonmusk"/>
                        </div>
                    </div>

                    <button class="focus:outline-none text-white bg-green-500 hover:bg-green-700 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800" onClick={()=>addData()}>Shree Ram</button>
                <div className='flex justify-between mx-6'>
                  <button onClick={()=>{data()}} type="button" class="focus:outline-none text-white bg-green-500 hover:bg-green-700 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800">Done</button>
                  <Link to="/detailForm" ><button type="button" class="py-2.5 px-5 me-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">Add more details-&gt;</button></Link>
                </div>

        </div> */}
        












        {/* <button onClick={()=>getData()}>Get Request</button>
        <button onClick={()=>postData({"name" : "sumit", "age" : 45, "Graduation" : "Siya Ram"})}>Post Request</button> */}
        {/* <button onClick={()=>RealTimeDatabase()} className='p-3  rounded-md w-fit font-bold text-xl hover:bg-gray-600 mt-4 bg-gray-400 text-red-500'> Post </button>
        <button onClick={()=>GetFirebaseData()} className='p-3  rounded-md w-fit font-bold text-xl hover:bg-gray-600 mt-4 bg-gray-400 text-red-500'> Get </button>
      <input type='file' onChange={(e)=>fireStoreData(e)}/> */}
{/* <InfiniteScroll
  loadMore = {()=>goToLoad}
  hasMore={true}
  loader={<div className="text-white">hello ji</div>}

>
    <div className="mx-auto w-[15rem] ">

     { [1,2,3,5,6,4,3,2,4,5,6,7,6,5,4,3,2].map((ele, idx)=>{
       return (
         <div key={idx} className="w-[14rem] h-1/4 my-2 bg-green-500">
            {ele} this is element
        </div>)
        
      })}
      
      </div>
  </InfiniteScroll>
 */}


 

 {/* <InfiniteScrollComponent/> */}



    </div>

    </>
  )
}

export default WorkingonIt